export const statusOptions = [
    "Scheduled",
    "Contacted",
    "Declined",
    "Not contacted",
  ];
  
  export const priorityOptions = [
    "All",
    "Emergency",
    "High",
    "Medium",
    "Low",
  ];

  export const referralOptions = [
    "All options",
    "Friends or Family",
    "Google",
    "Social Media",
    "Doctor",
    "Other",
  ];
  
  export const headerStatusOptions = [
    "All",
    "Scheduled",
    "Contacted",
    "Declined",
    "Not contacted",
  ];
  
  export const statusMap = {
    "All": "",
    "Scheduled": "scheduled",
    "Contacted": "contacted",
    "Declined": "declined",
    "Not contacted": "not_contacted"
  };
  
  export const priorityMap = {
    "All": "",
    "Emergency": "emergency",
    "High": "high",
    "Medium": "medium",
    "Low": "low"
  };

  export const referralMap = {
    "All options": "",
    "Friends or Family": "1",
    "Google": "2",
    "Social Media": "3",
    "Doctor": "4",
    "Other": "5"
  };
  
  export const reverseStatusMap = {
    "": "All",
    "scheduled": "Scheduled",
    "contacted": "Contacted",
    "declined": "Declined",
    "not_contacted": "Not contacted"
  };
  
  export const reversePriorityMap = {
    "": "All",
    "high": "High",
    "medium": "Medium",
    "low": "Low",
    "emergency": "Emergency"
  };

  export const reverseReferralMap = {
    "1": "Friends or Family",
    "2": "Google",
    "3": "Social Media",
    "4": "Doctor",
    "5": "Other"
  };

  export const cellStatusOptions = [
    "Scheduled",
    "Contacted",
    "Declined",
    "Not contacted",
  ];